import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { AboutSection } from './components/AboutSection';
import { ExperiencesSection } from './components/ExperiencesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen font-sans bg-[#F5F1EA] selection:bg-[#D4A5D9] selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <AboutSection data-id="element-4" />
        <ExperiencesSection data-id="element-5" />
        <TestimonialsSection data-id="element-6" />
        <CTASection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}